export default __webpack_public_path__ + "static/media/cluster-marker-icon.45b6f194.png";